module.exports = __webpack_public_path__ + "img/step4.df2f64cd.png";